import { useState } from "react";
import { Eye, Loader2, X, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr, inr } from "@/lib/api";

export default function DraftPreview({ rc }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { setData((await api.post("/admin/rate-card/preview", { rate_card: rc })).data); } catch (e) { toast.error(formatErr(e)); }
    setBusy(false);
  };
  return (
    <>
      <button onClick={run} disabled={busy} className="inline-flex items-center gap-1 text-xs text-brand-line hover:text-white" data-testid="preview-draft-btn">
        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Eye className="w-3 h-3" />} Preview draft
      </button>
      {data && (
        <div className="fixed inset-0 z-[60] bg-brand-ink/60 backdrop-blur-sm grid place-items-center p-6" onClick={() => setData(null)} data-testid="draft-preview-modal">
          <div className="w-full max-w-2xl rounded-3xl bg-brand-cream p-7 shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-xs uppercase tracking-[0.2em] text-brand-accent">Draft preview</p>
                <h3 className="font-serif-display text-3xl text-brand-ink mt-1">What a client would pay</h3>
                <p className="text-sm text-brand-muted mt-1">Sample home: {data.sample}. {data.changes.length} unsaved change{data.changes.length === 1 ? "" : "s"}.</p>
              </div>
              <button onClick={() => setData(null)} className="p-2 text-brand-muted hover:text-brand-ink" data-testid="draft-preview-close"><X className="w-5 h-5" /></button>
            </div>
            <div className="mt-6 rounded-2xl border border-brand-line overflow-hidden">
              <div className="grid grid-cols-12 px-4 py-2 bg-brand-sand text-[10px] uppercase tracking-[0.15em] text-brand-muted-light"><span className="col-span-3">Package</span><span className="col-span-4 text-right">Live total</span><span className="col-span-1" /><span className="col-span-4 text-right">Draft total</span></div>
              {data.rows.map((r) => {
                const delta = r.current_total == null ? null : r.draft_total - r.current_total;
                return (
                  <div key={r.tier} className="grid grid-cols-12 items-center px-4 py-3 border-t border-brand-line text-sm" data-testid={`preview-row-${r.tier}`}>
                    <span className="col-span-3 font-serif-display text-xl text-brand-ink">{r.label}</span>
                    <span className="col-span-4 text-right font-mono-num text-brand-muted">{r.current_total == null ? "new" : inr(r.current_total)}<span className="block text-[10px]">{r.current_per_sqft ? `₹${r.current_per_sqft}/sq.ft` : ""}</span></span>
                    <span className="col-span-1 grid place-items-center text-brand-muted-light"><ArrowRight className="w-4 h-4" /></span>
                    <span className={`col-span-4 text-right font-mono-num ${delta ? (delta > 0 ? "text-brand-accent-dark" : "text-emerald-700") : "text-brand-ink"}`} data-testid={`preview-draft-${r.tier}`}>
                      {inr(r.draft_total)}<span className="block text-[10px]">₹{r.draft_per_sqft}/sq.ft{delta ? ` · ${delta > 0 ? "+" : "−"}${inr(Math.abs(delta))}` : " · no change"}</span>
                    </span>
                  </div>
                );
              })}
            </div>
            <p className="text-xs text-brand-muted-light mt-4">Nothing is saved until you press "Save changes".</p>
          </div>
        </div>
      )}
    </>
  );
}
